



import { Component, Vue, Prop } from "vue-property-decorator";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
import { ListItemDTO } from "../../Generated/ParticaAPI";
import { ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig } from "../../Models/Buttons";

@Component({
	name: "ContentStreamLevelList",
	components: { ActionListV2 }
})
export default class ContentStreamLevelList extends Vue {
	@Prop() private levels: ListItemDTO[];
	@Prop() private actions: ButtonConfig[];
	private eventHandler(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}
}
